<template>
    <button class="btn btn-primary" @click.prevent="$bus.$emit('quoteForm')">
        Get a quote
    </button>
</template>

<script>
    export default {
        name: 'get-quote-btn',
    };
</script>
